export const REQUEST_FORM_SUBMIT_PAYMENT = 'REQUEST_FORM_SUBMIT_PAYMENT';
export const SUCCESS_FORM_SUBMIT_PAYMENT = 'SUCCESS_FORM_SUBMIT_PAYMENT';
export const FAILURE_FORM_SUBMIT_PAYMENT = 'FAILURE_FORM_SUBMIT_PAYMENT';



// WEBPACK FOOTER //
// ./src/services/account/paymentrequest/request/constants.js